<template>
  <div class="app-root">
    <div class="mobile-shell">
      <router-view />
    </div>
  </div>
  <WalletScannerPopup />
  <WebModalPopup />
</template>

<script setup>
import WalletScannerPopup from '@/view/wallet/components/WalletScannerPopup.vue';
import WebModalPopup from '@/components/WebModalPopup.vue';
</script>

<style scoped>
.app-root {
  min-height: var(--app-viewport-height);
}
</style>
